import React from 'react';
import { Helmet } from 'react-helmet';
import './styles/About.css';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us - SARKAR TRADERS</title>
        <meta name="description" content="Learn more about SARKAR TRADERS - Our history, mission, and commitment to quality products and services." />
      </Helmet>
      
      <div className="about-page">
        <div className="container">
          <div className="about-content">
            <h1>About SARKAR TRADERS</h1>
            
            <section className="about-section">
              <h2>Our Story</h2>
              <p>
                SARKAR TRADERS was established with a vision to provide quality products and exceptional 
                service to customers in Domkal, Murshidabad, and the wider West Bengal region. Over the 
                years, we have built a reputation for reliability, integrity, and customer satisfaction.
              </p>
            </section>

            <section className="about-section">
              <h2>Our Mission</h2>
              <p>
                Our mission is to be the most trusted trading partner by delivering high-quality products 
                that meet and exceed customer expectations. We strive to maintain long-term relationships 
                with our clients through transparent business practices and consistent quality.
              </p>
            </section>

            <section className="about-section">
              <h2>Our Values</h2>
              <ul className="values-list">
                <li><strong>Quality:</strong> We never compromise on the quality of our products.</li>
                <li><strong>Integrity:</strong> We conduct business with honesty and transparency.</li>
                <li><strong>Customer Focus:</strong> Our customers are at the heart of everything we do.</li>
                <li><strong>Innovation:</strong> We continuously seek better ways to serve our customers.</li>
                <li><strong>Reliability:</strong> We deliver on our promises, every time.</li>
              </ul>
            </section>

            <section className="about-section">
              <h2>Why Choose Us</h2>
              <div className="why-choose-us">
                <div className="feature-box">
                  <h3>Quality Products</h3>
                  <p>We source only the finest products from trusted suppliers.</p>
                </div>
                <div className="feature-box">
                  <h3>Experience</h3>
                  <p>Years of experience in the trading industry.</p>
                </div>
                <div className="feature-box">
                  <h3>Customer Service</h3>
                  <p>Dedicated support team to assist you at every step.</p>
                </div>
                <div className="feature-box">
                  <h3>Timely Delivery</h3>
                  <p>We ensure prompt and reliable delivery of orders.</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;




